import { IDeclaracaoHastaPublica } from '../../../interfaces/IDeclaracoes';
import { IIdentificacaoBasica } from '../../../interfaces/IIdentificacaoBasica';
import { IMunicipio, IProcessoMinerario, ISubstancia } from '../../../interfaces/IProcessos';
import { useApiClient } from '../../../hooks/useApiClient';
import { ICodigoNcm } from '../../../interfaces/ICodigoNcm';
import { IRegimeTributacao } from 'interfaces/IRegimeTributacao';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getDeclaracoes = async (cnpj: string, ano: string, tipo: number) => {
    const resposta = await httpCall.get<IDeclaracaoHastaPublica[]>(
      `/dief-cfem/api/declaracao/hasta-publica/listar/${cnpj}/ano/${ano}`
    );

    return resposta.data;
  };

  const getIdentificacaoBasica = async (cnpj: string) => {
    const resposta = await httpCall.get<IIdentificacaoBasica>(`/dief-cfem/api/declarante/${cnpj}`);

    return resposta.data;
  };

  const getProcessosData = async (numeroProcesso: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(
      `/dief-cfem/api/processo-minerario/hasta-publica/${numeroProcesso}`
    );

    return resposta.data;
  };

  const postEnviarDeclaracao = async (declaracao: IDeclaracaoHastaPublica) => {
    await httpCall
      .post<IProcessoMinerario>(`/dief-cfem/api/declaracao/hasta-publica/enviar`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postSalvarRascunhoDeclaracao = async (declaracao: IDeclaracaoHastaPublica) => {
    await httpCall
      .post<IProcessoMinerario>(`/dief-cfem/api/declaracao/hasta-publica/rascunho`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getMunicipioByCodigoIBGE = async (codigoIBGE: string) => {
    const resposta = await httpCall.get<IMunicipio>(`/dief-cfem/api/localidade/municipio/${codigoIBGE}`);
    return resposta.data;
  };

  const getDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoHastaPublica>(`/dief-cfem/api/declaracao/${declaracaoID}`);
    return resposta.data;
  };

  const deleteDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.delete<IDeclaracaoHastaPublica>(
      `/dief-cfem/api/declaracao/retificacao/cancelar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRetificarDeclaracao = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoHastaPublica>(
      `/dief-cfem/api/declaracao/retificacao/retificar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRascunhoDeclaracao = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoHastaPublica>(
      `/dief-cfem/api/declaracao/hasta-publica/rascunho/${declaracaoID}`
    );
    return resposta.data;
  };

  const getMunicipioPorUf = async (uf: string) => {
    const resposta = await httpCall.get<IMunicipio[]>(`/dief-cfem/api/localidade/uf/${uf}`);

    return resposta.data;
  };

  const getSubstancias = async () => {
    const resposta = await httpCall.get<ISubstancia[]>(`/dief-cfem/api/substancia`);

    return resposta.data;
  };

  const getCodigosNCM = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(`/dief-cfem/api/ncm`);

    return resposta.data;
  };

  const getRegimesTributacao = async (cpfCnpj: string) => {
    const resposta = await httpCall.get<IRegimeTributacao[]>(`/dief-cfem/api/regime-tributacao/${cpfCnpj}`);
    return resposta.data;
  };

  return {
    getDeclaracaoById,
    getDeclaracoes,
    deleteDeclaracaoById,
    getIdentificacaoBasica,
    getProcessosData,
    postEnviarDeclaracao,
    postSalvarRascunhoDeclaracao,
    getMunicipioByCodigoIBGE,
    getRetificarDeclaracao,
    getRascunhoDeclaracao,
    getMunicipioPorUf,
    getSubstancias,
    getCodigosNCM,
    getRegimesTributacao,
  };
};
